const BROWSER_IDENT_HASH_KEY = 'arcubase_browser_ident_hash'

function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}

export function getOrCreateBrowserIdentHash(): string {
  const existing = window.localStorage.getItem(BROWSER_IDENT_HASH_KEY)
  if (existing && /^[0-9a-f]{64}$/.test(existing)) {
    return existing
  }

  const bytes = new Uint8Array(32)
  window.crypto.getRandomValues(bytes)
  const value = bytesToHex(bytes)
  window.localStorage.setItem(BROWSER_IDENT_HASH_KEY, value)
  return value
}
